import { List, ListItemIcon, ListItemText, ListItem } from "@mui/material";
import { NavLink } from "react-router-dom";
import { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
//Icons
import AccountsIcon from '@mui/icons-material/PermContactCalendar';
import DevicesIcon from '@mui/icons-material/Router';
import VidfleetIcon from '@mui/icons-material/Videocam';
import SettingsIcon from '@mui/icons-material/Settings';
import ReportsIcon from '@mui/icons-material/Assignment';
import TransactionsIcon from '@mui/icons-material/Assessment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DealersIcon from '@mui/icons-material/SupervisorAccount';
import SmsIcon from '@mui/icons-material/Sms';
import VideoReviewIcon from '@mui/icons-material/VideoCameraFront';


//Language
import { useIntl } from 'react-intl';

//Routes
const ROUTES = {
    dealers: "/app/dealers/list",
    accounts: "/app/accounts/list",
    useractivitylogs: "/app/useractivitylogs/list",
    keyfobs: "/app/keyfobs/list",
    geofences: "/app/accounts/geofences",
    devices: "/app/devices/list",
    vidfleet: "/app/vidfleet",
    pmusers: "/app/pmusers/list",
    packages: '/app/packages/list',
    maintenancewarnings: '/app/vidfleet/maintenancewarnings',
    cameralogs: '/app/vidfleet/cameralogs',
    dmsstatuses: '/app/vidfleet/dmsstatuses',
    powerlost: '/app/vidfleet/powerlost',
    sdcardstatus: '/app/vidfleet/sdcardstatus',
    firmwaresreview: '/app/vidfleet/firmwaresreview',
    whitelisteddevices: '/app/vidfleet/whitelisteddevices',
    jiraSummary: '/app/pmusers/jirasummary',
    manufacturers: '/app/manufacturers/list',
    cloudloginpage: '/app/cloudloginpage',
    reports: '/app/reports/list',
    dashboard: '/app/dashboard/main',
    alerttypes: '/app/alerttypes/list',
    transactions: '/app/transactions/list',
    scheduledactions: '/app/scheduledactions/list',
    events: '/app/events/list',
    unsubscribedcontacts: '/app/unsubscribedcontacts/list',
    simproviders: '/app/simproviders/list',
    simprovideraccounts: '/app/simprovideraccounts/list',
    smssystems: '/app/smssystems/list',
    maintenancewarningevents: '/app/maintenancewarningevents/list',
    tags: '/app/tags/list',
    brands: '/app/brands/list',
    videoreview: '/app/accounts/videoreview',
    migrations: '/app/importAccount/list',
};

//Actions
import {
    sendCommandOpenModal
} from 'Redux/actions';

import { HasPermission } from 'Core/security';

import CustomCollapse from './Collapse'

const MenuItemsList = (props) => {
    const { changePreferences } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.securityRedux);

    const hasEnabledRoutes = (items = []) => items.some((item) => {
        if (!item) return false;
        if (item.subRoutes?.length) return hasEnabledRoutes(item.subRoutes);
        return !item.disabled;
    });

    const accountSubRoutes = [
        {
            route: ROUTES.accounts,
            label: messages['menu_accounts'],
            disabled: !HasPermission(user, "cmp"),
        },
        {
            route: ROUTES.migrations,
            label: messages['menu_migrations'],
            disabled: !HasPermission(user, "mgrtns"),
        },
        {
            route: ROUTES.useractivitylogs,
            label: messages['menu_user_activity_logs'],
            disabled: !HasPermission(user, "act"),
        },
        {
            route: ROUTES.keyfobs,
            label: messages['menu_key_fobs'],
            disabled: !HasPermission(user, "kfb"),
        },
        {
            route: ROUTES.scheduledactions,
            label: messages['menu_scheduled_actions'],
            disabled: !HasPermission(user, "schact"),
        },
        {
            route: ROUTES.unsubscribedcontacts,
            label: messages['menu_unsubscribed_contacts'],
            disabled: !HasPermission(user, "unsbctc"),
        },
        {
            route: ROUTES.maintenancewarningevents,
            label: messages['menu_unsubscribed_warnings'],
            disabled: !HasPermission(user, "wrgs"),
        },
        {
            route: ROUTES.tags,
            label: messages['menu_account_tags'],
            disabled: !HasPermission(user, "pmtag"),
        }
    ];

    const vidfleetSubRoutes = [
        {
            route: ROUTES.firmwaresreview,
            label: messages['menu_firmwares_reviews'],
            disabled: !HasPermission(user, "vdfltfw"),
        },
        {
            route: ROUTES.maintenancewarnings,
            label: messages['menu_maintenance_warnings'],
            disabled: !HasPermission(user, "manw"),
        },
        {
            route: ROUTES.cameralogs,
            label: messages['menu_camera_logs'],
            disabled: !HasPermission(user, "camlog"),
        },
        {
            route: ROUTES.dmsstatuses,
            label: messages['menu_dms_statuses'],
            disabled: !HasPermission(user, "dmst"),
        },
        {
            route: ROUTES.powerlost,
            label: messages['menu_power_lost'],
            disabled: !HasPermission(user, "pwlst"),
        },
        {
            route: ROUTES.sdcardstatus,
            label: messages['menu_sd_card_status'],
            disabled: !HasPermission(user, "sdcards"),
        },
        {
            route: ROUTES.whitelisteddevices,
            label: messages['menu_white_listed_devices'],
            disabled: !HasPermission(user, "wlstd"),
        }
    ];

    const settingsDeviceSubRoutes = [
        {
            route: ROUTES.manufacturers,
            label: messages['manufacturers'],
            disabled: !HasPermission(user, "man"),
        },
        {
            route: ROUTES.alerttypes,
            label: messages['menu_alert_types'],
            disabled: !HasPermission(user, "alrttp"),
        },
        {
            route: ROUTES.events,
            label: messages['menu_events'],
            disabled: !HasPermission(user, "evnt"),
        },
    ];

    const settingsSimProviderSubRoutes = [
        {
            route: ROUTES.simproviders,
            label: messages['menu_sim_provider'],
            disabled: !HasPermission(user, "simp"),
        },
        {
            route: ROUTES.simprovideraccounts,
            label: messages['menu_sim_provider_accounts'],
            disabled: !HasPermission(user, "simpa")
        },
        {
            route: ROUTES.smssystems,
            label: messages['menu_sim_sms_systems'],
            disabled: !HasPermission(user, "smss")
        }
    ];

    const settingsSubRoutes = [
        {
            label: messages['menu_devices'],
            disabled: !hasEnabledRoutes(settingsDeviceSubRoutes),
            color: '#324b66',
            subRoutes: settingsDeviceSubRoutes
        },
        {
            label: messages['menu_sim_provider'],
            disabled: !hasEnabledRoutes(settingsSimProviderSubRoutes),
            color: '#324b66',
            subRoutes: settingsSimProviderSubRoutes
        },
        {
            route: ROUTES.brands,
            label: messages['menu_brands'],
            disabled: !HasPermission(user, "brnd"),
        },
        {
            route: ROUTES.pmusers,
            label: messages['menu_pm_users'],
            disabled: !HasPermission(user, "usr"),
        },
        {
            route: ROUTES.packages,
            label: messages['menu_packages'],
            disabled: !HasPermission(user, "rol"),
        },
        {
            route: ROUTES.jiraSummary,
            label: messages["menu_jira_summary"],
            disabled: !HasPermission(user, "js")
        },
        {
            route: ROUTES.cloudloginpage,
            label: messages['menu_cloud_lg_page'],
            disabled: !HasPermission(user, "lgnpage")
        }
    ];

    //List
    const MENU_LIST = [
        {
            route: ROUTES.dashboard,
            label: messages['menu_dashboard'],
            Icon: DashboardIcon,
            disabled: !HasPermission(user, "pmdash"),
        },
        {
            route: ROUTES.dealers,
            label: messages['menu_dealers'],
            Icon: DealersIcon,
            disabled: !HasPermission(user, "dea"),
        },
        {
            route: ROUTES.accounts,
            label: messages['menu_accounts'],
            Icon: AccountsIcon,
            disabled: !hasEnabledRoutes(accountSubRoutes),
            color: '#32465c',
            subRoutes: accountSubRoutes
        },
        {
            route: ROUTES.devices,
            label: messages['menu_devices'],
            Icon: DevicesIcon,
            disabled: !HasPermission(user, "unt"),
        },
        {
            route: '',
            label: messages['menu_bulk_sms'],
            Icon: SmsIcon,
            disabled: !HasPermission(user, "msms", 'u'),
            onClick: (e) => {
                {
                    e.preventDefault()
                    dispatch(sendCommandOpenModal({ massSMS: true }));
                }
            }
        },
        {
            route: ROUTES.reports,
            label: messages['menu_reports'],
            Icon: ReportsIcon,
            disabled: !HasPermission(user, "rpt"),
        },
        {
            route: ROUTES.transactions,
            label: messages['menu_transactions'],
            Icon: TransactionsIcon,
            disabled: !HasPermission(user, "trnsrqst"),
        },
        {
            route: ROUTES.videoreview,
            label: messages['menu_video_review'],
            Icon: VideoReviewIcon,
            disabled: !HasPermission(user, "vdrvw"),
        },
        {
            route: ROUTES.vidfleet,
            label: messages['menu_vidfleet'],
            Icon: VidfleetIcon,
            disabled: !hasEnabledRoutes(vidfleetSubRoutes),
            color: '#32465c',
            subRoutes: vidfleetSubRoutes
        },
        {
            route: ROUTES.pmusers,
            label: messages['menu_settings'],
            Icon: SettingsIcon,
            disabled: !hasEnabledRoutes(settingsSubRoutes),
            color: '#32465c',
            subRoutes: settingsSubRoutes
        },
    ]

    const open = useSelector(state => state.commonRedux.sidebarShow);

    const handleClick = (e, disabled) => {
        if (disabled) e.preventDefault()
    }

    return (
        <List>
            {MENU_LIST.filter((item) => !item?.disabled).map((item, index) => {
                const { Icon } = item
                return (
                    <Fragment key={index}>
                        {
                            !item.subRoutes && !item.disabled &&
                            <NavLink
                                onClick={(e) => {
                                    if (item?.route !== '')
                                        handleClick(e, item.disabled)
                                    else {
                                        item.onClick(e)
                                    }
                                }}
                                to={!item.disabled ? item.route : "#"}
                                style={{ textDecoration: 'none', color: 'white' }}
                            >
                                {({ isActive }) => (
                                    <ListItem
                                        disabled={item.disabled}
                                        button
                                        style={{
                                            color: 'white',
                                            background: isActive && '#142843',
                                            justifyContent: 'inherit',
                                            padding: '8px 16px',
                                        }}>
                                        <ListItemIcon>
                                            <Icon style={{ color: 'white' }} />
                                        </ListItemIcon>
                                        {
                                            open &&
                                            <div>
                                                <ListItemText style={{ fontSize: '0.8rem' }} primary={item.label} />
                                            </div>
                                        }

                                    </ListItem>
                                )}
                            </NavLink>
                        }
                        {
                            item.subRoutes && !item.disabled && <CustomCollapse option={item} Icon={Icon} openDrawer={open} />
                        }

                    </Fragment>
                )
            })}
        </List>
    )
}

export default MenuItemsList;
